import $ from '@vaersaagod/tools/Dom';
import Flickity from 'flickity';

export default el => {
    const dom = $(el);
    const items = dom.find('[data-text]');

    let flkty;

    const init = () => {
        if (items.length > 1) {
            flkty = new Flickity(dom.find('[data-text-wrap]').get(0), {
                cellSelector: '[data-text]',
                wrapAround: true,
                contain: true,
                pageDots: false,
                prevNextButtons: false,
                draggable: false,
                dragThreshold: 10,
                cellAlign: 'center',
                setGallerySize: true,
                percentPosition: true,
                accessibility: false,
                autoPlay: 3000,
                pauseAutoPlayOnHover: false
            });
        }
    };

    const destroy = () => {
        if (items.length > 1) {
            flkty.destroy();
        }
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/FrontText.js